import { t } from '@lingui/core/macro';

import { CHANNEL_ID_PAID_SEARCH } from '@/constants/channel';
import type { FilterComponentProps } from '@/providers/TableState';

import AdFilter from './AdFilter';

type Props = FilterComponentProps & {
  mode?: 'multiple' | 'single';
  hasExclude?: boolean;
};

const KeywordFilter = ({ mode, ...props }: Props) => {
  return (
    <AdFilter
      {...props}
      channelId={CHANNEL_ID_PAID_SEARCH}
      placeholder={mode === 'single' ? t`Select Keyword...` : t`Select Keywords...`}
      mode={mode}
      notFoundContent={t`No keywords were found...`}
      data-testid="keyword-filter"
    />
  );
};

export default KeywordFilter;
